var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSolShiftPlanning01 = function SvgSolShiftPlanning01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sol_shift_planning-01_svg2__a",
    x1: 14.31,
    x2: 154.36,
    y1: 175.56,
    y2: 10.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3fe5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#f434e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#dd1de7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#cd0ce8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c403e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c100e9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_shift_planning-01_svg2__a",
    id: "sol_shift_planning-01_svg2__b",
    x1: 67.69,
    x2: 207.74,
    y1: 220.9,
    y2: 56.01
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_shift_planning-01_svg2__a",
    id: "sol_shift_planning-01_svg2__c",
    x1: 11.31,
    x2: 151.36,
    y1: 173.02,
    y2: 8.12
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_shift_planning-01_svg2__a",
    id: "sol_shift_planning-01_svg2__d",
    x1: 14.46,
    x2: 154.51,
    y1: 175.69,
    y2: 10.79
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_shift_planning-01_svg2__a",
    id: "sol_shift_planning-01_svg2__e",
    x1: 14.32,
    x2: 154.36,
    y1: 175.57,
    y2: 10.67
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_shift_planning-01_svg2__a",
    id: "sol_shift_planning-01_svg2__f",
    x1: 37.31,
    x2: 177.36,
    y1: 195.1,
    y2: 30.21
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_shift_planning-01_svg2__a",
    id: "sol_shift_planning-01_svg2__g",
    x1: 37.17,
    x2: 177.22,
    y1: 194.98,
    y2: 30.09
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_shift_planning-01_svg2__a",
    id: "sol_shift_planning-01_svg2__h",
    x1: 60.17,
    x2: 200.22,
    y1: 214.51,
    y2: 49.62
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_shift_planning-01_svg2__a",
    id: "sol_shift_planning-01_svg2__i",
    x1: 60.03,
    x2: 200.08,
    y1: 214.39,
    y2: 49.5
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_shift_planning-01_svg2__a",
    id: "sol_shift_planning-01_svg2__j",
    x1: 58.42,
    x2: 198.47,
    y1: 213.03,
    y2: 48.13
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_shift_planning-01_svg2__a",
    id: "sol_shift_planning-01_svg2__k",
    x1: 35.57,
    x2: 175.61,
    y1: 193.62,
    y2: 28.72
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_shift_planning-01_svg2__a",
    id: "sol_shift_planning-01_svg2__l",
    x1: 81.28,
    x2: 221.33,
    y1: 232.44,
    y2: 67.55
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M168.37 59.19h-6.64a41.1 41.1 0 0 0 4.08-17.89c0-22.77-18.53-41.3-41.3-41.3-12.03 0-23.16 5.09-31.01 14.04-3.41-2.55-7.63-4.08-12.21-4.08-11.28 0-20.46 9.18-20.46 20.46 0 4.56 1.52 8.76 4.05 12.16h-3c-8.74 0-15.86 7.11-15.86 15.86v.75h-14.4c-3.76 0-6.82 3.06-6.82 6.82v91.42c0 1.61 1.3 2.91 2.91 2.91s2.91-1.3 2.91-2.91V66.01c0-.55.45-.99.99-.99h14.4v18.9c0 3.76 3.06 6.82 6.82 6.82h1.84c1.61 0 2.91-1.3 2.91-2.91s-1.3-2.91-2.91-2.91h-1.84c-.55 0-.99-.45-.99-.99V58.46c0-5.53 4.5-10.03 10.03-10.03h8.76l4.43 11.66-5.03 24.84h-1.68c-1.61 0-2.91 1.3-2.91 2.91s1.3 2.91 2.91 2.91h41.4c3.76 0 6.82-3.06 6.82-6.82v-2.11c2.61.51 5.27.79 7.94.79 13.95 0 26.3-6.96 33.78-17.58h10.08c.55 0 .99.45.99.99v18.75c0 1.61 1.3 2.91 2.91 2.91s2.91-1.3 2.91-2.91V66.02c0-3.76-3.06-6.82-6.82-6.82Zm-85.91-2.28H80.1l-2.42-6.37c1.18.21 2.38.34 3.62.34s2.38-.13 3.53-.33zM81.3 15.79c8.07 0 14.63 6.56 14.63 14.63S89.37 45.05 81.3 45.05s-14.63-6.56-14.63-14.63 6.56-14.63 14.63-14.63m-5.32 69.12 4.49-22.17h1.62l4.39 22.17zm34.77-.99c0 .55-.45.99-.99.99H92.42l-4.91-24.84 4.35-11.66h8.87c5.53 0 10.03 4.5 10.03 10.03v25.47Zm33.95-13.48-.38-.66a2.92 2.92 0 0 0-3.98-1.07c-1.39.8-1.87 2.59-1.07 3.98l.39.67a35.2 35.2 0 0 1-12.24 3.28v-.77c0-1.61-1.3-2.91-2.91-2.91s-2.91 1.3-2.91 2.91v.77c-1.7-.14-3.38-.4-5.03-.78V58.44c0-8.74-7.11-15.86-15.86-15.86h-3c2.53-3.4 4.05-7.6 4.05-12.16s-1.55-8.84-4.12-12.26c1.99-2.32 4.24-4.33 6.68-6.03l.39.68c.54.93 1.52 1.46 2.53 1.46.49 0 .99-.13 1.45-.39 1.39-.8 1.87-2.59 1.07-3.98l-.4-.69c3.81-1.8 7.94-2.91 12.25-3.25v.77c0 1.61 1.3 2.91 2.91 2.91s2.91-1.3 2.91-2.91v-.77c4.35.36 8.47 1.49 12.24 3.28l-.39.67c-.8 1.39-.33 3.17 1.07 3.98.46.27.96.39 1.45.39 1.01 0 1.99-.52 2.52-1.46l.38-.66c3.49 2.43 6.53 5.46 8.95 8.95l-.66.38c-1.39.8-1.87 2.59-1.07 3.98.54.93 1.52 1.46 2.52 1.46.49 0 .99-.13 1.45-.39l.67-.39c1.79 3.76 2.92 7.89 3.28 12.24h-.77c-1.61 0-2.91 1.3-2.91 2.91s1.3 2.91 2.91 2.91h.77c-.36 4.35-1.49 8.47-3.28 12.24l-.67-.39a2.915 2.915 0 0 0-2.91 5.05l.66.38a35.7 35.7 0 0 1-8.95 8.95Z",
    style: {
      fill: "url(#sol_shift_planning-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.28 95.52c-1.61 0-2.91 1.3-2.91 2.91v94.74c0 .55-.45.99-.99.99H31.63c-.55 0-.99-.45-.99-.99V171.1c0-1.61-1.3-2.91-2.91-2.91s-2.91 1.3-2.91 2.91v22.07c0 3.76 3.06 6.82 6.82 6.82h136.74c3.76 0 6.82-3.06 6.82-6.82V98.43c0-1.61-1.3-2.91-2.91-2.91Z",
    style: {
      fill: "url(#sol_shift_planning-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.64 38.39h-12.21V20.37c0-1.61-1.3-2.91-2.91-2.91s-2.91 1.3-2.91 2.91v20.94c0 1.61 1.3 2.91 2.91 2.91h15.12c1.61 0 2.91-1.3 2.91-2.91s-1.3-2.91-2.91-2.91Z",
    style: {
      fill: "url(#sol_shift_planning-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.58 105.88H48.16c-1.61 0-2.91 1.3-2.91 2.91v25c0 1.61 1.3 2.91 2.91 2.91h25c1.61 0 2.91-1.3 2.91-2.91v-5.24c0-1.61-1.3-2.91-2.91-2.91s-2.91 1.3-2.91 2.91v2.32H51.07v-19.18h9.51c1.61 0 2.91-1.3 2.91-2.91s-1.3-2.91-2.91-2.91Z",
    style: {
      fill: "url(#sol_shift_planning-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.21 116.91a2.92 2.92 0 0 0-4.11-.22 2.91 2.91 0 0 0-.22 4.11l4.56 5.07c.55.62 1.34.96 2.16.96h.18c.89-.05 1.7-.51 2.21-1.24l10.55-15.14c.92-1.32.6-3.14-.72-4.06a2.926 2.926 0 0 0-4.06.72l-8.45 12.13-2.11-2.34Z",
    style: {
      fill: "url(#sol_shift_planning-01_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.92 105.88H87.5c-1.61 0-2.91 1.3-2.91 2.91v25c0 1.61 1.3 2.91 2.91 2.91h25c1.61 0 2.91-1.3 2.91-2.91v-5.24c0-1.61-1.3-2.91-2.91-2.91s-2.91 1.3-2.91 2.91v2.32H90.41v-19.18h9.51c1.61 0 2.91-1.3 2.91-2.91s-1.3-2.91-2.91-2.91Z",
    style: {
      fill: "url(#sol_shift_planning-01_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.55 116.91a2.92 2.92 0 0 0-4.11-.22 2.91 2.91 0 0 0-.22 4.11l4.56 5.07c.55.62 1.34.96 2.16.96h.18c.89-.05 1.7-.51 2.21-1.24l10.55-15.14c.92-1.32.6-3.14-.72-4.06a2.926 2.926 0 0 0-4.06.72l-8.45 12.13-2.11-2.34Z",
    style: {
      fill: "url(#sol_shift_planning-01_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.26 105.88h-12.42c-1.61 0-2.91 1.3-2.91 2.91v25c0 1.61 1.3 2.91 2.91 2.91h25c1.61 0 2.91-1.3 2.91-2.91v-5.24c0-1.61-1.3-2.91-2.91-2.91s-2.91 1.3-2.91 2.91v2.32h-19.18v-19.18h9.51c1.61 0 2.91-1.3 2.91-2.91s-1.3-2.91-2.91-2.91Z",
    style: {
      fill: "url(#sol_shift_planning-01_svg2__h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.89 116.91a2.92 2.92 0 0 0-4.11-.22 2.91 2.91 0 0 0-.22 4.11l4.56 5.07c.55.62 1.34.96 2.16.96h.18c.89-.05 1.7-.51 2.21-1.24l10.55-15.14c.92-1.32.6-3.14-.72-4.06a2.93 2.93 0 0 0-4.06.72l-8.45 12.13-2.11-2.34Z",
    style: {
      fill: "url(#sol_shift_planning-01_svg2__i)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.58 176.58c0 1.61 1.3 2.91 2.91 2.91h25c1.61 0 2.91-1.3 2.91-2.91v-25c0-1.61-1.3-2.91-2.91-2.91h-25c-1.61 0-2.91 1.3-2.91 2.91zm5.83-22.1h19.18v19.18H90.41z",
    style: {
      fill: "url(#sol_shift_planning-01_svg2__j)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.24 176.58c0 1.61 1.3 2.91 2.91 2.91h25c1.61 0 2.91-1.3 2.91-2.91v-25c0-1.61-1.3-2.91-2.91-2.91h-25c-1.61 0-2.91 1.3-2.91 2.91zm5.83-22.1h19.18v19.18H51.07z",
    style: {
      fill: "url(#sol_shift_planning-01_svg2__k)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.93 176.58c0 1.61 1.3 2.91 2.91 2.91h25c1.61 0 2.91-1.3 2.91-2.91v-25c0-1.61-1.3-2.91-2.91-2.91h-25c-1.61 0-2.91 1.3-2.91 2.91zm5.82-22.1h19.18v19.18h-19.18z",
    style: {
      fill: "url(#sol_shift_planning-01_svg2__l)"
    }
  }));
};
export default SvgSolShiftPlanning01;